// extracted by mini-css-extract-plugin
module.exports = {"newGame":"WinGame_newGame__3XtRC","rainbow":"WinGame_rainbow__1xZ7o","win":"WinGame_win__1Oshq","button_menu":"WinGame_button_menu__3QQXc","info":"WinGame_info__8ItJ_"};